<template lang="html">
    <Chart></Chart>
</template>

<script>
import Chart from './chart.vue';

export default {
  components: {
    Chart
  }
};
</script>
